// extracted by mini-css-extract-plugin
export default {"root":"VdSrbL","icon":"tVumML","label":"mSzR61"};